/**
 * §17 white-label — one brand contract for the web app, the API and the exports.
 * Precedence: project → tenant → Fyr base. Text on a brand colour is chosen by WCAG contrast, so a client can pick
 * any colour and labels on it stay readable.
 */
export const BASE_BRAND = { name: 'Fyr', primary: '#217346' };
export const HEX_COLOUR = /^#[0-9a-f]{6}$/;
export const isHexColour = (s) => typeof s === 'string' && HEX_COLOUR.test(s);
const channel = (c) => {
    const v = c / 255;
    return v <= 0.03928 ? v / 12.92 : ((v + 0.055) / 1.055) ** 2.4;
};
/** WCAG 2.x relative luminance of a #rrggbb colour. */
export function luminance(hex) {
    const n = parseInt(hex.slice(1), 16);
    return 0.2126 * channel((n >> 16) & 255) + 0.7152 * channel((n >> 8) & 255) + 0.0722 * channel(n & 255);
}
export function contrastRatio(a, b) {
    const [l1, l2] = [luminance(a), luminance(b)].sort((x, y) => y - x);
    return (l1 + 0.05) / (l2 + 0.05);
}
/** White or near-black text — whichever reads better on `bg`. */
export function contrastText(bg) {
    return contrastRatio(bg, '#ffffff') >= contrastRatio(bg, '#1b1b1a') ? '#ffffff' : '#1b1b1a';
}
export const BRAND_IMAGE_KINDS = ['logo', 'favicon'];
/** PNG / JPEG only: they embed in the PDF and Word deliverables (WebP can't), and SVG can carry script. */
export const BRAND_IMAGE_TYPES = {
    png: 'image/png',
    jpg: 'image/jpeg',
    jpeg: 'image/jpeg',
};
export const BRAND_IMAGE_MAX_KB = 1024;
export function resolveBrand(tenantName, tenant, project) {
    const primary = project?.primary ?? tenant?.primary ?? BASE_BRAND.primary;
    const accent = project?.accent ?? tenant?.accent ?? primary;
    return {
        name: tenant?.displayName ?? tenantName,
        primary,
        primaryContrast: contrastText(primary),
        accent,
        accentContrast: contrastText(accent),
        logoAssetId: project?.logoAssetId ?? tenant?.logoAssetId ?? null,
        faviconAssetId: tenant?.faviconAssetId ?? null,
        from: {
            primary: project?.primary ? 'project' : tenant?.primary ? 'tenant' : 'base',
            logo: project?.logoAssetId ? 'project' : tenant?.logoAssetId ? 'tenant' : null,
        },
    };
}
//# sourceMappingURL=brand.js.map